import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { StoreState } from '@src/meta/types/store';
import { setAccount } from '@src/actions/accounts';
import { CustomerAccountInfo } from '@modules/auth/components/types/customer-account';
import { fetchWithHandling } from '@src/utils/fetching';
import CustomerAccountResource from '@src/services/Identity/CustomerAccountResource';

type PropsFromState = {
  account: CustomerAccountInfo;
  userId: string;
};

type PropsFromDispatch = {
  setAccount: any;
};

type Props = PropsFromState & PropsFromDispatch;

function AccountRefresher({ userId, account, setAccount }: Props) {
  useEffect(() => {
    fetchWithHandling(
      () => CustomerAccountResource.info({ customerAccountId: account.id, userId }),
      undefined,
      res => setAccount(res),
    );
  }, []);
  return null;
}

const mapDispatchToProps: PropsFromDispatch = {
  setAccount,
};

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    account: state.account.account,
    userId: state.auth.configurableUser!.id,
  };
}

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(AccountRefresher);
